export default __webpack_public_path__ + "static/mundo-3d7abd5ec9187524315a4da12b48a6fc.png";